<template>
  <div class="scene-preview-container-parent" ref="scenePreviewContainerParent">
    <resize-observer @notify="onSceneContainerResize"/>
    <div class="scene-preview-container" ref="scenePreviewContainer" :style="{ 'top': top + 'px' }">
      <div class="creative-vuetify-md-response">
        <v-layout class="mobile-scene-tools-container">
          <carousel
            :per-page="redoButton ? 5 : 4"
            :mouse-drag="true"
            :paginationEnabled="false"
            :paginationSize="4"
            :paginationPadding="5"
            :navigationEnabled="false"
          >
            <slide>
              <label-button
                svg="tools/undo.svg"
                :label="$t('undo')"
                :disabled="!commands.length"
                @click="revert"
              />
            </slide>
            <slide v-if="redoButton">
              <label-button
                svg="tools/redo.svg"
                :label="$t('redo')"
                :disabled="!revertedCommands.length || $store.getters.scene.tasks > 0"
                @click="redo"
              />
            </slide>
            <slide>
              <label-button
                svg="tools/delete.svg"
                :label="$t('removeElement')"
                :disabled="!selectedElements.length"
                @click="removeElements"
              />
            </slide>
            <slide>
              <label-button svg="tools/center.svg" :label="$t('center')" @click="center"/>
            </slide>
            <slide>
              <label-button
                svg="tools/open.svg"
                :label="toogleFrontText"
                :toggled="!$store.getters.scene.areFrontsVisible"
                @click="toggleFronts"
              />
            </slide>
          </carousel>
        </v-layout>
      </div>
      <div class="creative-canvas-container">
        <canvas id="canvas" ref="sceneCanvas" touch-action="none"></canvas>
        <label-button
          v-show="!isChangeHandlePositionButtonDisabled()"
          svg="tools/switch.svg"
          :label="$t('changeHandlePosition')"
          :disabled="isChangeHandlePositionButtonDisabled()"
          :absolute="true"
          :position="frontScepialButtonPosition"
          @click="changeHandlePosition"
        />
        <div v-show="placeholderShow" class="scene-placeholder fade" ref="placeholder">
          <v-img v-show="placeholder" :src="placeholder" v-on:load="placeholderOnLoad"></v-img>
        </div>
        <div class="d-none d-md-flex">
          <div id="buttons-panel">
            <label-button
              svg="tools/undo.svg"
              :label="$t('undo')"
              :disabled="!commands.length || placeholderShow"
              @click="revert"
            />
            <label-button
              v-show="redoButton"
              svg="tools/redo.svg"
              :label="$t('redo')"
              :disabled="!revertedCommands.length || $store.getters.scene.tasks > 0"
              @click="redo"
            />
            <label-button
              v-show="$store.getters.isAdvancedOptionsProduct"
              svg="tools/delete.svg"
              :label="$t('removeElement')"
              :disabled="!selectedElements.length"
              @click="removeElements"
              :tooltip="$t('tooltipDelete')"
            />
            <label-button svg="tools/center.svg" :label="$t('center')" @click="center"/>
            <label-button
              v-show="$store.getters.isAdvancedOptionsProduct"
              svg="tools/open.svg"
              :label="toogleFrontText"
              :toggled="!$store.getters.scene.areFrontsVisible"
              @click="toggleFronts"
            />
          </div>
        </div>
        <v-progress-circular
          v-if="$store.getters.scene.tasks"
          class="loading-indicator"
          indeterminate
          width="4"
          size="40"
        />
        <v-progress-circular
          v-if="$store.getters.scene.tasks"
          class="loading-indicator"
          color="#fff"
          indeterminate
          width="2"
          size="40"
        />
        <div
          v-if="$store.getters.scene.tasks"
          class="loading-indicator"
        >{{$store.getters.scene.tasksPercentage}}%</div>
        <v-snackbar
          :class="[ messager.contentClass, 'd-none d-md-flex creative-snack-margin']"
          v-model="messager.show"
          :timeout="messager.timeout"
          :color="messager.color"
          :vertical="messager.vertical"
          :absolute="messager.desktopAbsolute"
          :outlined="true"
          top
        >
          <v-btn
            icon
            color="black"
            dark
            small
            @click="messager.close()"
            class="creative-snackbar-close-btn"
          >
            <svg-icon path="tools/close.svg"></svg-icon>
          </v-btn>
          <div class="creative-snack-arrow"></div>
          <p class="creative-snackbar-text">{{messager.text}}</p>
        </v-snackbar>
      </div>
    </div>
  </div>
</template>
<script>
import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import TemplatesModule from "@/store/modules/templates";
import {
  Vector3,
  Mesh,
  Scene,
  Engine,
  Camera,
  Color3,
  Color4,
  PointLight,
  ArcRotateCamera,
  StandardMaterial,
  AbstractMesh,
  Material,
  HighlightLayer,
  Vector2,
  CubeTexture,
  SceneLoader,
  HemisphericLight,
  PBRMetallicRoughnessMaterial,
  Texture,
  BaseTexture,
  MeshBuilder
} from "@babylonjs/core";
import * as BABYLON from "@babylonjs/loaders";
import Cell from "@/models/cell.ts";
import Area from "@/models/area.ts";
import Element from "@/models/element.ts";
import Construction from "@/models/construction.ts";
import ICommand from "@/models/command/ICommand.ts";
import AddElementCommand from "@/models/command/addElementCommand.ts";
import "@babylonjs/loaders";
import { PostProcess } from "@/models/postProcess.ts";
import { SceneConfiguration } from "@/models/sceneConfiguration.ts";
import { ElementType, SpecyficType } from "@/models/element";
import RemoveElementsCommand from "@/models/command/removeElementsCommand.ts";
import ChangeColorCommand from "@/models/command/changeColorCommand.ts";
import ResetColorsCommand from "@/models/command/resetColorsCommand.ts";
import ChangeLegsCommand from "@/models/command/changeLegsCommand.ts";
import ChangeHandlesCommand from "@/models/command/changeHandlesCommand.ts";
import ChangeHandlePositionCommand from "@/models/command/changeHandlePositionCommand.ts";
import { positionManager } from "@/models/positionManager.ts";
import { placementManager } from "@/models/placementManager.ts";
import { slotsManager } from "@/models/slotsManager.ts";
import { innerSlotsManager } from "@/models/innerSlotsManager.ts";
import { wallManager } from "@/models/wallManager.ts";
import { handlesManager } from "@/models/handlesManager.ts";
import { hingesManager } from "@/models/hingesManager.ts";
import { sectionCreator } from "@/models/sectionCreator.ts";
import { materialFactory } from "@/models/materials/materialFactory.ts";
import LabelButton from "@/components/LabelButton.vue";
import { ShaderNBaza } from "@/models/shaders/legs/shader_n_baza.ts";
import { ShaderShadow } from "@/models/shaders/others/shader_shadow.ts";
import { ShaderHdf } from "@/models/shaders/others/shader_hdf.ts";
import { ShaderEdge } from "@/models/shaders/others/shader_edge.ts";
import { Shader01Rafix } from "@/models/shaders/others/shader_01_rafix.ts";
import { ShaderZawias } from "@/models/shaders/others/shader_zawias.ts";
import { ShaderSlot } from "@/models/shaders/others/shader_slot.ts";
import { ShaderTasma } from "@/models/shaders/others/shader_tasma.ts";
import { ShaderGasket } from "@/models/shaders/others/shader_gasket.ts";
import { stringUtil } from "@/models/stringUtil.ts";
import { messager, Messager } from "@/models/messager.ts";
import { SlotElement } from "@/models/slotElement.ts";
import { SlotsInteractionManager } from "@/models/slotsInteractionManager.ts";
import { presets } from "@/models/presets";
import { PresetSet } from "@/models/api/models/preset";
import { regionManager } from "@/models/region/regionManager.ts";
import { regionHelperManager } from "@/models/region/regionHelperManager.ts";
import { ScreenMaker } from "@/models/screenMaker";
import { Carousel, Slide } from "vue-carousel";
import { PresetData } from "@/models/presets.ts";
import materialStore from "@/models/shaders/MaterialStore.ts";
import * as d3 from "d3";
import { ClonePresetLoader } from "@/models/loaders/presets/clonePresetLoader.ts";
import { StandardPresetLoader } from "@/models/loaders/presets/standardPresetLoader.ts";
import SvgIcon from "@/components/SvgIcon.vue";

export default {
  data() {
    return {
      scene: null,
      engine: null,
      camera: null,
      highlightLayer: null,
      highlightColor: Color3.Red(),
      boundries: [],
      cells: [],
      areas: [],
      elements: [],
      constructions: [],
      commands: [],
      revertedCommands: [],
      product: null,
      sceneConfiguration: null,
      messager: messager,
      slotElements: [],
      slotsInteractionManager: new SlotsInteractionManager(this),
      placeholder: "",
      placeholderShow: false,
      regionElements: [],
      usePlaceholder: true,
      currentHandler: null,
      frontScepialButtonPosition: null,
      presetLoader: null,
      previewTop: 0,
      redoButton: false,
      canvasHeight:
        this.$store.getters.configuration.tiny === "true" ? 500 : 700
    };
  },
  components: {
    LabelButton,
    Carousel,
    Slide,
    SvgIcon
  },
  computed: {
    canvas() {
      return document.getElementById("canvas");
    },
    selectedElements() {
      return this.elements.filter(x => x.isSelected);
    },
    freeSlots() {
      const element = this.$store.getters.scene.selectedElementMenuItem;
      return innerSlotsManager.createSlots(element);
    },
    toogleFrontText() {
      const canHaveBigFronts = this.$store.getters.product.canHaveBigFronts;
      const close = canHaveBigFronts
        ? "toggleFrontsClose"
        : "altToggleFrontsClose";
      const open = canHaveBigFronts
        ? "toggleFrontsOpen"
        : "altToggleFrontsOpen";
      return this.$store.getters.scene.areFrontsVisible
        ? this.$t(close)
        : this.$t(open);
    },
    top() {
      return this.previewTop ? this.previewTop : 0;
    }
  },
  watch: {
    canvasStyle(newStyle) {
      this.engine.resize();
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    onSceneContainerResize(e) {
      this.updateScenePosition();
      setTimeout(() => {
        this.engine.resize();
      }, 0);
    },
    handleScroll(event) {
      this.updateScenePosition();
    },
    haveToUpdateScenePosition() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    haveToScrollAfterMenuSelection() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    updateScenePosition() {
      if (this.haveToUpdateScenePosition()) {
        var spc = this.$refs.scenePreviewContainer;
        var spcp = this.$refs.scenePreviewContainerParent;
        if (spc && spcp) {
          const t = spc.getBoundingClientRect().top;
          const h = this.canvasHeight;
          const T = spcp.getBoundingClientRect().top;
          const H = spcp.getBoundingClientRect().height;
          if (T < 0) {
            if (h + Math.abs(T) < H) {
              this.previewTop = Math.abs(T);
            } else {
              this.previewTop = H - h;
            }
          } else {
            this.previewTop = 0;
          }
        }
      } else {
        this.previewTop = 0;
      }
    },
    createScene(engine) {
      //BABYLON.Database.IDBStorageEnabled = true;
      //BABYLON.Database.IDBStorageEnabled = true;

      const scene = new Scene(engine);

      scene.autoClear = false; // Color buffer
      scene.autoClearDepthAndStencil = false; // Depth and stencil, obviously
      scene.blockMaterialDirtyMechanism = true;

      this.scene = scene;
      const sceneConfiguration = new SceneConfiguration(scene, this.canvas);
      this.sceneConfiguration = sceneConfiguration;
      sceneConfiguration.run();
      const postProcess = new PostProcess(scene);
      postProcess.run();
      this.handleEvents();
      this.highlightLayer = new HighlightLayer("hl1", scene, {
        blurHorizontalSize: 0.3,
        blurVerticalSize: 0.3
      });

      return scene;
    },
    loadModel(product, callback) {
      // const model = "lozko_korpus.gltf";
      // const light = "lozko_korpus_light.jpg";
      const shader = this.$store.getters.shaders.selectedBody;
      this.addElement(
        product.model,
        product.light,
        shader,
        new Vector2((1 + product.shape.x) / 2, (1 + product.shape.y) / 2),
        product.shape,
        () => {
          callback();
          // this.addElement(
          //   "lozko_materac.gltf",
          //   "lozko_materac_light.jpg",
          //   shader,
          //   Vector2.Zero(),
          //   Vector2.Zero(),
          //   () => {}
          // );
          // this.addElement(
          //   "lozko_n_baza.gltf",
          //   "lozko_n_baza_light.jpg",
          //   shader,
          //   Vector2.Zero(),
          //   Vector2.Zero(),
          //   () => {}
          // );
          // this.addElement(
          //   "lozko_n_box.gltf",
          //   "lozko_n_box_light.jpg",
          //   shader,
          //   Vector2.Zero(),
          //   Vector2.Zero(),
          //   () => {}
          // );
          // this.addElement(
          //   "lozko_wspornik.gltf",
          //   "lozko_wspornik_light.jpg",
          //   shader,
          //   Vector2.Zero(),
          //   Vector2.Zero(),
          //   (x) => {
          //     console.log(x)
          //   }
          // );
          // if (product.depth > 255) {
          //   this.loadLegs(product);
          // }
          // this.createSlots();
          regionHelperManager.initialize(this);
          regionHelperManager.createHelpers();
          this.$store.commit("setProductLoaded", true);
        }
      );
    },
    loadLegs(product) {
      const shader = new ShaderNBaza();
      this.addElement(
        `n_baza_${product.width}x${product.depth}.gltf`,
        `n_baza_${product.width}x${product.depth}_light.jpg`,
        shader,
        Vector2.Zero(),
        Vector2.Zero()
      );

      const legs = this.$store.getters.shaders.selectedLegs;
      this.addElement(
        stringUtil.fillLegsPath(legs.model),
        stringUtil.fillLegsPath(legs.light),
        legs.shader,
        Vector2.Zero(),
        Vector2.Zero()
      );
    },
    createSlots() {
      const shader = new ShaderSlot();
      const material = this.getMaterial(shader, "");
      for (let i = 1; i <= this.product.shape.x; i++) {
        for (let j = 1; j <= this.product.shape.y; j++) {
          const shape = new Vector2(1, 1);
          const position = new Vector2(i, j);
          const width = positionManager.cellWidth - 3;
          const height = positionManager.cellHeight - 3;
          const depth = positionManager.cellDepth - 1;
          const material = material; //this.getMaterial(shader, "");
          const slot = MeshBuilder.CreateBox(
            "slot",
            { height, width, depth },
            this.scene
          );
          slot.material = material;
          const slotElement = new SlotElement(position, shape, [slot]);
          this.slotElements.push(slotElement);
          slotElement.isVisible = false;
          positionManager.position(slotElement);
        }
      }

      for (let i = 1; i <= this.product.shape.x; i++) {
        for (let j = 1; j <= this.product.shape.y; j += 0.5) {
          const shape = new Vector2(1, 0);
          const position = new Vector2(i, j);
          const width = positionManager.cellWidth - 3;
          const height = 5;
          const depth = positionManager.cellDepth - 1;
          const material = this.getMaterial(shader, "");
          const slot = MeshBuilder.CreateBox(
            "slot",
            { height, width, depth },
            this.scene
          );
          slot.material = material;
          const slotElement = new SlotElement(position, shape, [slot], true);
          this.slotElements.push(slotElement);
          slotElement.isVisible = false;
          positionManager.position(slotElement);
        }
      }
    },
    importModel(scene, meshgltf, light, shader, shadowmat, process = x => {}) {
      this.$store.commit("incrementTasks");
      SceneLoader.ImportMesh(
        "",
        this.$store.getters.configuration.baseUrl,
        meshgltf,
        scene,
        meshes => {
          const material = this.getMaterial(shader, light);
          meshes.forEach(mesh => {
            //mesh.convertToUnIndexedMesh();
            //mesh.freezeWorldMatrix();
            mesh.scaling = new Vector3(1, 1, 1);
            const splitted = mesh.name.split("_");
            const type = splitted[splitted.length - 1];
            if (
              splitted[0] === "hang" &&
              splitted[splitted.length - 1] === "zasl"
            ) {
              const material = this.getMaterial(shader, `${mesh.name}.jpg`);
              mesh.material = material;
            } else if (mesh.name === 'b_korpus_uszczelka') {
              const shader = new ShaderGasket();
              const light = stringUtil.toGasketLight(meshgltf);
              const material = this.getMaterial(shader, light);
              mesh.material = material;
            } else if (type == "shadow") {
              const shader = new ShaderShadow();
              const shadow = this.getMaterial(
                shader,
                stringUtil.toShadowLight(meshgltf)
              );
              mesh.material = shadow;
            } else if (type == "rafix") {
              const shader = this.$store.getters.shaders.selectedRafix;
              const rafixMaterial = this.getMaterial(
                shader,
                stringUtil.toRafixLight(meshgltf)
              );
              mesh.material = rafixMaterial;
            } else if (mesh.name.includes("tasma")) {
              const shader = new ShaderTasma();
              const tasma = this.getMaterial(shader, "");
              mesh.material = tasma;
            } else if (type == "hdf") {
              const shader = new ShaderHdf();
              const hdfMaterial = this.getMaterial(shader, "");
              mesh.material = hdfMaterial;
            } else if (type == "szyna") {
              const shader = new ShaderZawias();
              const material = this.getMaterial(shader, light);
              mesh.material = material;
            } else if (mesh.name.includes("edge")) {
              const shader = new ShaderEdge();
              const material = this.getMaterial(shader, "");
              mesh.material = material;
            } else {
              mesh.material = material;
            }
          });
          const newElement = this.createElement(
            meshgltf,
            light,
            shader,
            meshes
          );
          if (newElement.type === ElementType.BODY) {
            // this.sceneConfiguration.setTarget(newElement);
          }
          process(newElement);
          newElement.freeze(true);
          this.$store.commit("decrementTasks");
        },
        x => {},
        x => {
          this.$store.commit("decrementTasks");
        }
      );
    },
    getMaterial(shader, light) {
      const m = materialStore.getMaterial(shader.key);

      let material =
        m != null
          ? m
          : materialStore.addMaterial(
              shader.key,
              shader.getMaterial(this.scene, null)
            );

      material = shader.addLight(this.scene, material, light);
      // material.freeze();

      if (material.baseTexture) {
        this.$store.commit("incrementTasks");
        material.baseTexture.onLoadObservable.add(() => {
          this.$store.commit("decrementTasks");
        });
      }
      if (material.normalTexture) {
        this.$store.commit("incrementTasks");
        material.normalTexture.onLoadObservable.add(() => {
          this.$store.commit("decrementTasks");
        });
      }
      if (material.lightmapTexture) {
        this.$store.commit("incrementTasks");
        material.lightmapTexture.onLoadObservable.add(() => {
          this.$store.commit("decrementTasks");
        });
      }
      return material;
    },
    createElement(meshgltf, light, shader, meshes) {
      const newElement = new Element(
        meshgltf,
        light,
        shader.key,
        new Vector2(0, 0),
        new Vector2(0, 0),
        meshes
      );
      if (newElement.type == ElementType.BODY) {
        positionManager.initialize(newElement);
        slotsManager.initialize(newElement);
      }
      this.elements.push(newElement);
      return newElement;
    },
    hidePlaceholder() {
      if (this.usePlaceholder) {
        setTimeout(() => {
          var ph = this.$refs.placeholder;
          if (ph) {
            ph.classList.add("active");
          }
          setTimeout(() => {
            this.placeholderShow = false;
          }, 300);
        }, 0);
      }
    },
    loadPresetFromString(string) {
      const preset = JSON.parse(string);
      const data = PresetData.adapt(preset);
      this.loadPreset(data);
    },
    loadPreset(data) {
      this.presetLoader.load(data);
    },
    createMaterial(light) {
      return materialFactory.get("H3395", this.scene, light);
    },
    changeColors(type, shader, onlySelected = false) {
      let elements = this.elements.filter(
        x => x.type === type && (onlySelected ? x.isSelected : true)
      );
      if (type === ElementType.INSIDE) {
        elements = elements.filter(x => x.specyficType === SpecyficType.SHELF);
      }

      if (elements.length) {
        this.loadNewSceneState(() => {
          const changeColorCommand = new ChangeColorCommand(
            this,
            elements,
            shader,
            () => this.$store.commit("incrementTasks"),
            () => this.$store.commit("decrementTasks"),
            onlySelected
          );
          this.addCommand(changeColorCommand);
        });
      } else {
        const text = !onlySelected
          ? this.$t("noElements").toString()
          : this.$t("noElementsSelected").toString();
        messager.info(text);
      }
    },
    addSingleElement() {
      const addElementCommand = new AddElementCommand(this);
      this.addCommand(addElementCommand);
    },
    loadNewSceneState(callback) {
      if (!this.usePlaceholder) {
        callback();
      } else {
        var ph = this.$refs.placeholder;
        if (!ph) {
          callback();
        } else {
          ph.classList.remove("active");
          var screenMaker = new ScreenMaker(x => {
            if (x) {
              if (this.placeholder === x) {
                this.placeholderOnLoad();
              } else {
                this.placeholder = x;
              }
            } else {
              this.placeholderOnLoad();
            }
          });

          // wywoływany jak placeholder będzie gotowy.

          this.currentHandler = callback;

          screenMaker.preparePanel(
            this.scene,
            this.engine,
            this.sceneConfiguration,
            this.getSceneSize()
          );
        }
      }

      if (this.haveToScrollAfterMenuSelection()) {
        this.$scrollTo("#creative-menu-header");
      }
    },
    handleEvents() {
      const scene = this.scene;
      const ground = scene.getMeshByName("ground");
      const camera = scene.getCameraByName("Camera");
      const canvas = document.getElementById("canvas");
      let lastMousePosition;

      const onPointerDown = evt => {
        lastMousePosition = new Vector2(scene.pointerX, scene.pointerY);
        if (evt.button !== 0) {
          return;
        }
      };

      const pointerOffset = 2;

      const onPointerUp = () => {
        if (!lastMousePosition) return;
        let pickedElement;
        const pickInfo = scene.pick(scene.pointerX, scene.pointerY);

        if (
          scene.pointerX < lastMousePosition.x - pointerOffset ||
          scene.pointerX > lastMousePosition.x + pointerOffset ||
          scene.pointerY < lastMousePosition.y - pointerOffset ||
          scene.pointerY > lastMousePosition.y + pointerOffset
        ) {
          return;
        }

        if (pickInfo.pickedMesh == null) {
          this.elements.forEach(x => {
            this.selectElement(x, false);
            this.$store.commit("clearSceneState");
          });
          return;
        }

        if (pickInfo.hit) {
          const mesh = pickInfo.pickedMesh;
          if (mesh.name.includes("shadow")) {
            return;
          }
          pickedElement = this.getElementByMesh(mesh);
          // console.log(pickedElement);
          if (
            pickedElement &&
            pickedElement != null &&
            pickedElement.isSelectable
          ) {
            this.selectElement(pickedElement, !pickedElement.isSelected);
            this.elements.forEach(x => {
              if (x !== pickedElement) {
                this.selectElement(x, false);
              }
            });

            if (!this.isChangeHandlePositionButtonDisabled()) {
              var meshPos = this.getClientRectFromMesh(mesh);
              if (meshPos) {
                this.frontScepialButtonPosition = {
                  x: meshPos.right,
                  y: meshPos.bottom
                };
              }
            }
          }
          this.slotsInteractionManager.onPointerUp();
          regionManager.onPointerUp();
        }
      };

      const onMouseMove = () => {
        this.slotsInteractionManager.onMouseMove();
        regionManager.getSlot();
      };

      const onKeyUp = e => {
        if (e.keyCode === 46) {
          // on delete
          if (this.selectedElements.length) {
            this.removeElements();
          }
        }
        if (e.keyCode === 16) {
          // console.log(this.scene.cameras[0].position.clone());
        }
      };

      canvas.addEventListener("pointerdown", onPointerDown, false);
      canvas.addEventListener("pointerup", onPointerUp, false);
      canvas.addEventListener("mousemove", onMouseMove, false);
      window.addEventListener("keyup", onKeyUp, false);

      scene.onDispose = () => {
        canvas.removeEventListener("pointerdown", onPointerDown);
        canvas.removeEventListener("pointerup", onPointerUp);
        canvas.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("keyup", onKeyUp);
      };

      this.$store.subscribe((mutation, state) => {
        if (mutation.type === "center") {
          this.center();
        }
        if (
          mutation.type === "setProductLoaded" &&
          this.$store.getters.scene.productLoaded &&
          this.$store.getters.configuration.presetCustomerUrl !== ""
        ) {
          this.getCustomerProduct();
        }
        if (mutation.type === "selectSlotItem") {
          this.loadNewSceneState(this.addSingleElement);
        }
        if (mutation.type === "selectPreset") {
          this.loadNewSceneState(this.loadPresetOnScene);
        }
        if (mutation.type === "selectElementMenuItem") {
          regionHelperManager.showFreeHelpers();
          // const freeSlots = this.freeSlots;
          // freeSlots.forEach(x => (x.isVisible = true));
          // // this.slotsInteractionManager.clearHighlight();

          // const availableSlots = slotsManager.createSlots(element);
          // if (!this.availableSlots.length) {
          //   if (this.haveToScrollAfterMenuSelection()) {
          //     this.$scrollTo("#creative-menu-header");
          //   }
          // }

          if (this.haveToScrollAfterMenuSelection()) {
            this.$scrollTo("#creative-menu-header");
          }

          // todo: przenieść funkcjonalność z SlotsPreview.
        }
        if (mutation.type === "clearSceneState") {
          regionHelperManager.hideHelpers();
          // this.slotElements.forEach(x => (x.isVisible = false));
          this.regionElements.forEach(x => x.remove());
          this.regionElements = [];
        }
        if (
          mutation.type === "decrementTasks" &&
          this.$store.getters.scene.tasks === 0 &&
          this.$store.getters.scene.selectedElementMenuItem
        ) {
          const selectedElementMenuItem = this.$store.getters.scene
            .selectedElementMenuItem;
          this.$store.commit("clearSceneState");
          this.$store.commit("selectElementMenuItem", selectedElementMenuItem);
        }
        if (
          mutation.type === "decrementTasks" &&
          this.$store.getters.scene.tasks === 0
        ) {
          this.hidePlaceholder();
          this.$store.dispatch("sapCalculate");
        }
        if (mutation.type === "setFrontsVisibility") {
          this.elements
            .filter(
              x => x.type === ElementType.FRONT || x.type === ElementType.HANDLE
            )
            .forEach(
              x => (x.isVisible = this.$store.getters.scene.areFrontsVisible)
            );
        }
      });
    },

    getClientRectFromMesh(mesh) {
      const meshVectors = mesh.getBoundingInfo().boundingBox.vectors;
      const worldMatrix = mesh.getWorldMatrix();
      const transformMatrix = this.scene.getTransformMatrix();
      const camera = this.scene.cameras[0];
      const viewport = camera ? camera.viewport : null;

      if (!viewport) {
        return null;
      } else {
        const coordinates = meshVectors.map(v => {
          const proj = Vector3.Project(
            v,
            worldMatrix,
            transformMatrix,
            viewport
          );
          proj.x = proj.x * canvas.clientWidth;
          proj.y = proj.y * canvas.clientHeight;
          return proj;
        });

        const [minX, maxX] = d3.extent(coordinates, c => c.x);
        const [minY, maxY] = d3.extent(coordinates, c => c.y);

        const rect = {
          width: maxX - minX,
          height: maxY - minY,
          left: minX,
          top: minY,
          right: maxX,
          bottom: maxY
        };

        return rect;
      }
    },

    loadPresetOnScene() {
      const preset = this.$store.getters.scene.selectedPreset;
      this.loadPreset(preset.data);
      this.commands.splice(0, this.commands.length);
      this.revertedCommands.splice(0, this.revertedCommands.length);
    },
    getSceneSize() {
      var h = this.$refs.sceneCanvas.clientHeight;
      var w = this.$refs.sceneCanvas.clientWidth;
      return { width: w, height: h };
    },
    selectElement(element, isSelected) {
      element.isSelected = isSelected;
      element.meshes.forEach(x => {
        if (isSelected) {
          this.highlightLayer.addMesh(x, this.highlightColor);
        } else {
          this.highlightLayer.removeMesh(x);
        }
      });
    },
    addElementClick() {
      // const command = new AddElementCommand(this);
      // command.execute();
      // this.commands.push(command);
      //console.log(this.areas);
      this.$emit("cellsSelected", this.cells.filter(x => x.isSelected));
    },
    addElement(name, light, shader, position, size, then = element => {}) {
      this.importModel(this.scene, name, light, shader, null, x => {
        x.position = position;
        x.shape = size;
        positionManager.position(x);
        then(x);
      });
    },
    changeLegs(legs) {
      this.loadNewSceneState(() => {
        const command = new ChangeLegsCommand(this, legs);
        this.addCommand(command);
      });
    },
    changeHandles(handle) {
      var hasAnyFronts = this.$store.getters.scene.elements.filter(
        x => x.type === ElementType.FRONT
      ).length;
      if (hasAnyFronts) {
        this.loadNewSceneState(() => {
          const command = new ChangeHandlesCommand(this, handle);
          this.addCommand(command);
        });
      } else {
        const text = this.$t("noFronts").toString();
        messager.info(text);
      }
    },
    revert() {
      if (this.commands.length > 0) {
        this.loadNewSceneState(() => {
          this.elements.forEach(x => {
            this.selectElement(x, false);
          });
          const command = this.commands.pop();
          command.revert();
          this.$store.dispatch("sapCalculate");
          this.revertedCommands.push(command);
          this.$store.commit("clearSceneState");
        });
      }
    },
    redo() {
      if (this.revertedCommands.length) {
        const command = this.revertedCommands.pop();
        this.loadNewSceneState(() => {
          this.addCommand(command, false);
        });
      }
    },
    getElementByMesh(mesh) {
      return this.elements.find(x => x.meshes.includes(mesh));
    },
    toggleFronts() {
      this.loadNewSceneState(() => {
        this.$store.commit("clearSceneState");
        this.$store.commit("toggleFrontsVisibility");
        this.elements
          .filter(
            x => x.type === ElementType.FRONT || x.type === ElementType.HANDLE
          )
          .forEach(x => {
            x.isVisible = this.$store.getters.scene.areFrontsVisible;
          });
      });
    },
    resetColors() {
      this.loadNewSceneState(() => {
        const resetColorsCommand = new ResetColorsCommand(this);
        this.addCommand(resetColorsCommand);
      });
    },
    changeHandlePosition() {
      const front = this.selectedElements[0];
      const command = new ChangeHandlePositionCommand(front, this);
      this.loadNewSceneState(() => {
        this.addCommand(command);
      });
    },
    isChangeHandlePositionButtonDisabled() {
      return !(
        this.selectedElements.length === 1 &&
        this.selectedElements[0].type === ElementType.FRONT &&
        handlesManager.canChangeHandlePosition(this.selectedElements[0])
      );
    },
    center() {
      this.sceneConfiguration.centerCamera();
    },
    removeElements() {
      const command = new RemoveElementsCommand(
        this.elements,
        this.selectedElements,
        this
      );
      this.loadNewSceneState(() => {
        this.addCommand(command);
        const selectedElementMenuItem = this.$store.getters.scene
          .selectedElementMenuItem;
        if (!selectedElementMenuItem) {
          return;
        }
        this.$store.commit("selectElementMenuItem", selectedElementMenuItem);
      });
    },
    addCommand(command, clearRevertedCommands = true) {
      this.elements.forEach(x => {
        this.selectElement(x, false);
      });
      this.commands.push(command);
      command.execute();
      if (clearRevertedCommands) {
        this.revertedCommands = [];
      }
    },
    getAllPresets() {
      this.$store.commit("incrementTasks");
      this.$store.commit("setPresetsLoaded", false);
      this.$api
        .getAllPresets(this.$store.getters.configuration.productId)
        .then(
          presetSet => {
            this.handlePresetSet(presetSet);
          },
          error => {
            this.$store.commit("hideLoadingScreen");
          }
        )
        .finally(x => this.$store.commit("decrementTasks"));
    },
    getCustomerProduct() {
      this.$store.commit("incrementTasks");
      const url = this.$store.getters.configuration.presetCustomerUrl;
      this.$api
        .getCustomerPreset(url)
        .then(
          preset => {
            this.loadPreset(preset);
          },
          error => {
            this.$store.commit("hideLoadingScreen");
          }
        )
        .finally(x => this.$store.commit("decrementTasks"));
    },
    getProductInfo() {
      this.$store.commit("incrementTasks");
      this.$store.commit("setProductLoaded", false);
      this.$api
        .getProduct(this.$store.getters.configuration.productId)
        .then(
          product => {
            this.handleProduct(product);
            this.getAllPresets();
          },
          error => {
            this.$store.commit("hideLoadingScreen");
            this.$store.commit("setLoadingProductError", true);
          }
        )
        .finally(x => this.$store.commit("decrementTasks"));
    },
    getConfig() {
      this.$store.commit("incrementTasks");
      this.$store.commit("setProductLoaded", false);
      this.$store.commit("setPresetsLoaded", false);
      this.$api
        .getConfig(this.$store.getters.configuration.productId)
        .then(
          config => {
            this.handleProduct(config.product);
            this.handlePresetSet(config.presetSet);
          },
          error => {
            this.$store.commit("hideLoadingScreen");
            this.$store.commit("setLoadingProductError", true);
          }
        )
        .finally(x => this.$store.commit("decrementTasks"));
    },
    handleProduct(product) {
      this.product = product;
      this.$store.commit("setProduct", product);
      this.loadModel(product, () => {
        this.sceneConfiguration.centerCamera();
      });
      this.$store.commit("setPresets", {
        appPreset: product.appPreset,
        appPresetInterior: product.appPresetInterior
      });
      sectionCreator.update(this.$store.getters.product);
    },
    handlePresetSet(p) {
      const id = this.$store.getters.configuration.productId;
      presets.AddCompletePresets(p.complete, id);
      presets.AddInnerPresets(p.inner);
      this.$store.commit("setPresetsLoaded", true);
    },
    setWatches() {
      this.$watch("elements", (val, oldVal) => {
        // const price = val.map(e => e.price).reduce((a, b) => a + b, 0);
        // this.$store.commit("setPrice", price);
      });
    },
    placeholderOnLoad() {
      if (!this.placeholderShow) {
        this.placeholderShow = true;
        if (this.currentHandler) {
          this.currentHandler();
          if (this.$store.getters.scene.tasks === 0) {
            this.hidePlaceholder();
          }
        }
      }
    }
  },
  mounted() {
    const message = this.$t("loadingScene").toString();
    this.$store.commit("showLoadingScreen", message);

    placementManager.initialize(this.elements);
    wallManager.initialize(this.elements);
    handlesManager.initialize(this.elements);
    hingesManager.initialize(this.elements);
    innerSlotsManager.initialize(this.elements, this.slotElements);
    regionManager.initialize(this);
    this.presetLoader = new ClonePresetLoader(this);
    // this.presetLoader = new StandardPresetLoader(this);

    this.setWatches();
    this.$store.commit("setElements", this.elements);

    const engine = new Engine(this.canvas, true, {
      doNotHandleContextLost: true,
      preserveDrawingBuffer: true,
      stencil: true
    });
    this.engine = engine;
    const scene = this.createScene(engine);

    engine.runRenderLoop(() => {
      if (this.$store.getters.scene.tasks === 0) {
        scene.render();
      }
    });

    // this.getConfig();
    this.getProductInfo();
    sectionCreator.initialize(this);

    this.$emit(
      "engineCreated",
      this.engine,
      this.scene,
      this.sceneConfiguration
    );
  },
  destroyed() {
    this.engine.stopRenderLoop();
  }
};
</script>
<style scoped>
#canvas {
  width: 100%;
  height: 100%;
  outline: none;
}
#buttons-panel {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100px;
  text-align: center;
}
.loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.mobile-scene-tools-container {
  padding-top: 16px;
  width: 100%;
}
.mobile-scene-tools-container > div.VueCarousel {
  width: 100%;
}
.scene-placeholder {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
}
.fade {
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  -moz-transition: opacity 0.3s ease-in-out;
  -webkit-transition: opacity 0.3s ease-in-out;
}
.fade.active {
  opacity: 0;
}
.creative-snack-margin {
  margin-top: 0px;
}
.scene-preview-container {
  position: absolute;
  width: 100%;
  left: 0px;
}
.scene-preview-container-parent {
  position: relative;
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 959px) {
  .scene-preview-container {
    position: relative;
  }
  .scene-placeholder {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
}
@media only screen and (min-width: 960px) {
  .creative-vuetify-md-response {
    display: none;
  }
}
</style>
